import { menu, menuShop } from './menu_shop'
import { menuEva } from './menu_eva'

const menu_ = [menu, menuEva, menuShop]

export default menu_ 